<div id="image-area">
  <div id="select-files"></div>
</div>
